// import parent theme js
import '../../../../aurora-institute/resources/assets/scripts/main.js';


// WEBPACK FOOTER //
// ./scripts/main.js